/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Guest_Field_NameInputs */

const vi_meeting_guest_field_name = /** @type {(inputs: Meeting_Guest_Field_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tên khách`)
};

/**

* @param {Meeting_Guest_Field_NameInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const meeting_guest_field_name = /** @type {((inputs?: Meeting_Guest_Field_NameInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Guest_Field_NameInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_meeting_guest_field_name(inputs)
});